import wx from 'weixin-js-sdk'
import { getSignatureWx } from '@/api/share'


// import axios from 'axios'
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// function getSignatureWx(params) {
//   return axios({
//     url: "/api/wx/getSignature",
//     method: "get",
//     params: { data: JSON.stringify(params) },
//   });
// }

export function getSignature(dataForWeixin) {
  let url = location.href
  console.log(url)
  let obj = {
    url: url
  }
  getSignatureWx(obj).then(res => {
    console.log(res)
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.data.appId,    // 必填，公众号的唯一标识
      timestamp: res.data.timestamp,  // 必填，生成签名的时间戳
      nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      signature: res.data.signature,// 必填，签名
      jsApiList: [
        'onMenuShareAppMessage',      // 微信分享
        'onMenuShareTimeline',        // 分享朋友圈
        // 'updateAppMessageShareData',
        // 'updateTimelineShareData',
      ], // 必填，需要使用的JS接口列表
      // success: () => {
      //   alert('success')
      // },
    });
    wx.ready(function () {
      //分享给朋友
      wx.onMenuShareAppMessage({
        title: dataForWeixin.title, // 分享标题
        desc: dataForWeixin.desc, // 分享描述
        link: location.href, // 分享链接
        imgUrl: dataForWeixin.imgUrl, // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      });
      wx.onMenuShareTimeline({
        title: dataForWeixin.title, // 分享标题
        desc: dataForWeixin.desc, // 分享描述
        link: location.href, // 分享链接
        imgUrl: dataForWeixin.imgUrl, // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      });
    })
    wx.error(function (res) {
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      console.log("配置分享结果" + JSON.stringify(res));
    });
  })
}
